import { HeadphonesIcon, Mail, MessageSquare, ExternalLink } from "lucide-react"
import { Button } from "@/components/ui/button"
import { EMAIL_SUPPORT, APP_NAME } from "@/lib/appConfig"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function SupportWidget() {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="relative group">
                    <HeadphonesIcon className="h-5 w-5 text-muted-foreground group-hover:text-foreground transition-colors" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-72 p-2">
                <DropdownMenuLabel className="flex items-center gap-2 px-2 py-1">
                    <div className="p-1.5 bg-primary/10 rounded-lg">
                        <HeadphonesIcon className="h-3.5 w-3.5 text-primary" />
                    </div>
                    <span className="font-semibold text-sm">Help & Support</span>
                </DropdownMenuLabel>
                <DropdownMenuSeparator className="my-2" />

                <div className="px-2 py-1 space-y-3">
                    <p className="text-xs text-muted-foreground leading-relaxed">
                        Need help with {APP_NAME}? Our support team is here to assist you. We typically respond within 24 hours.
                    </p>

                    <div className="space-y-1.5">
                        <div className="flex items-center gap-2 text-xs font-medium text-muted-foreground uppercase tracking-wide px-1">
                            <MessageSquare className="h-3 w-3" />
                            Contact Support
                        </div>
                        <a
                            href={`mailto:${EMAIL_SUPPORT}`}
                            className="flex items-center justify-between gap-2 rounded-xl border border-border px-3 py-2.5 hover:bg-muted/60 transition-colors group/link"
                        >
                            <div className="flex items-center gap-2.5 min-w-0">
                                <Mail className="h-4 w-4 text-primary shrink-0" />
                                <span className="text-sm font-medium text-foreground truncate">{EMAIL_SUPPORT}</span>
                            </div>
                            <ExternalLink className="h-3.5 w-3.5 text-muted-foreground group-hover/link:text-foreground transition-colors shrink-0" />
                        </a>
                    </div>

                    <div className="rounded-xl bg-muted/40 border border-border/40 px-3 py-2.5">
                        <p className="text-xs font-medium text-foreground mb-0.5">Response time</p>
                        <p className="text-xs text-muted-foreground">Usually within 24 hours on business days</p>
                    </div>
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
